'use client';

import { usePathname } from 'next/navigation';
import { useCallback, useMemo } from 'react';
import Discord from '@/components/Icons/SocialMono/Discord';
import TikTok from '@/components/Icons/SocialMono/TikTok';
import TwitterX from '@/components/Icons/SocialMono/TwitterX';
import { Button } from '@music-vine/cadence/ui';
import { logEvent } from '@/pages/api/v1/utils';
import { InstagramIcon } from './svg/InstagramIcon';
import { YouTubeIcon } from './svg/YouTubeIcon';
export const SocialLinks = () => {
  const asPath = usePathname();
  const logFooterClick = useCallback((type: string, text: string, nextPath: string) => {
    void logEvent({
      event_type: 'click',
      asPath: asPath ?? '',
      metadata: {
        type,
        text,
        next_path: nextPath
      }
    });
  }, [asPath]);
  const socialIconButtons = useMemo(() => [{
    title: 'Discord',
    href: 'https://discord.gg/q5xaCqhGFC',
    icon: <Discord className="size-6 fill-black md:size-8 dark:fill-white" />,
    onClick: () => {
      logFooterClick('footer_social_discord', 'Discord', 'https://discord.gg/q5xaCqhGFC');
    }
  }, {
    title: 'Instagram',
    href: 'https://www.instagram.com/UppbeatOfficial/',
    icon: <InstagramIcon className="size-5 md:size-7" />,
    onClick: () => {
      logFooterClick('footer_social_instagram', 'Instagram', 'https://www.instagram.com/UppbeatOfficial/');
    }
  }, {
    title: 'Youtube',
    href: 'https://www.youtube.com/@uppbeat',
    icon: <YouTubeIcon className="size-5 md:size-8" />,
    onClick: () => {
      logFooterClick('footer_social_youtube', 'Youtube', 'https://www.youtube.com/@uppbeat');
    }
  }, {
    title: 'Twitter (X)',
    href: 'https://twitter.com/UppbeatOfficial',
    icon: <TwitterX className="size-5 fill-gray-950 md:size-8 dark:fill-white" />,
    onClick: () => {
      logFooterClick('footer_social_twitter', 'Twitter', 'https://twitter.com/UppbeatOfficial');
    }
  }, {
    title: 'TikTok',
    href: 'https://www.tiktok.com/@uppbeat',
    icon: <TikTok className="size-5 fill-gray-950 md:size-8 dark:fill-white" />,
    onClick: () => {
      logFooterClick('footer_social_tiktok', 'TikTok', 'https://www.tiktok.com/@uppbeat');
    }
  }], [logFooterClick]);
  return <div className="mb-8 flex items-center justify-start gap-6 md:mb-0 md:justify-center" data-sentry-component="SocialLinks" data-sentry-source-file="SocialLinks.tsx">
      {socialIconButtons.map(item => <div className="flex md:size-10 md:items-center md:justify-center" key={item.title}>
          <Button asChild className="max-md:size-10 max-md:rounded-full max-md:bg-gray-100 max-md:hover:bg-gray-200 max-md:dark:bg-gray-800 max-md:dark:hover:bg-gray-700" size="icon" variant="transparent">
            <a href={item.href} onClick={item.onClick} rel="noopener noreferrer" target="_blank" title={item.title}>
              {item.icon}
            </a>
          </Button>
        </div>)}
    </div>;
};